import { render } from "./FundAmountForm.vue?vue&type=template&id=4c71d310&scoped=true"
import script from "./FundAmountForm.vue?vue&type=script&lang=js"
export * from "./FundAmountForm.vue?vue&type=script&lang=js"

import "./FundAmountForm.vue?vue&type=style&index=0&id=4c71d310&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c71d310"]])

export default __exports__